module.exports = __webpack_public_path__ + "img/tu10.535638f5.png";